<template>
  <RevDialog
    :name="MODAL_NAMES.CANCEL_AUTO_RENEWAL_MODAL"
    :title="i18n(translations.title)"
    @close="
      tracking.trackClick({
        zone: TRACKING_ZONES.CANCEL_AUTO_RENEWAL_MODAL,
        name: 'close-cancel-auto-renewal-modal',
      })
    "
  >
    <template #body>
      <div class="space-y-16">
        <RevIllustration
          alt=""
          aria-hidden="true"
          class="w-full"
          :height="200"
          :src="'/img/insurance/autoRenewCancellation.png'"
          :width="300"
        />

        <div class="space-y-8">
          <div class="text-static-default-hi heading-3">
            {{ i18n(translations.confirmationHeading) }}
          </div>

          <FormattedMessage
            class="text-static-default-hi body-1"
            :definition="translations.description"
          >
            <template #endDate>
              <span class="body-1-bold">{{ formattedEndDate }}</span>
            </template>
          </FormattedMessage>
        </div>
      </div>
    </template>

    <template #footer="{ close }">
      <div class="space-y-12">
        <RevButton
          full-width="always"
          :tracking="{
            zone: TRACKING_ZONES.CANCEL_AUTO_RENEWAL_MODAL,
            name: 'cancel-auto-renewal',
          }"
          variant="primary"
          @click="onCancelAutoRenewal"
        >
          {{ i18n(translations.cancelAutoRenewal) }}
        </RevButton>

        <RevButton
          full-width="always"
          :tracking="{
            zone: TRACKING_ZONES.CANCEL_AUTO_RENEWAL_MODAL,
            name: 'keep-auto-renewal',
          }"
          variant="secondary"
          @click="close"
        >
          {{ i18n(translations.keepAutoRenewal) }}
        </RevButton>
      </div>
    </template>
  </RevDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'
import { RevDialog } from '@ds/components/Dialog'
import { RevIllustration } from '@ds/components/Illustration'
import { closeModal } from '@ds/components/ModalBase'

import {
  INSURANCE_DATE_FORMAT,
  MODAL_NAMES,
  TRACKING_ZONES,
} from '~/scopes/dashboard/services-hub/constant'

import translations from './CancelAutoRenewalModal.translations'

const props = defineProps<{
  endDate: string | null
}>()

const emit = defineEmits(['cancel-auto-renewal'])
const tracking = useTracking()
const i18n = useI18n()

const formattedEndDate = computed(() =>
  i18n.date(new Date(props.endDate ?? ''), INSURANCE_DATE_FORMAT),
)

function onCancelAutoRenewal() {
  emit('cancel-auto-renewal')
  closeModal(MODAL_NAMES.CANCEL_AUTO_RENEWAL_MODAL)
}
</script>
